import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getApiDefinitionArticles } from '../../services/api-repositories/api-definitions-repository';
import { initialArticlesState } from './types';

export const fetchArticles = createAsyncThunk(
  'articles/fetchArticles',
  async (apiId: string) => {
    const articles = await getApiDefinitionArticles(apiId);
    return { apiId, articles };
  },
);

const articlesSlice = createSlice({
  name: 'articles',
  initialState: initialArticlesState,
  reducers: {
    clearArticlesError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchArticles.pending, (state, action) => {
        const apiId = action.meta.arg;
        state.loading[apiId] = true;
        state.error = null;
      })
      .addCase(fetchArticles.fulfilled, (state, action) => {
        const { apiId, articles } = action.payload;
        state.loading[apiId] = false;
        state.articlesByApiId[apiId] = articles;
      })
      .addCase(fetchArticles.rejected, (state, action) => {
        const apiId = action.meta.arg;
        state.loading[apiId] = false;
        state.error = action.error.message || 'Failed to fetch articles';
      });
  },
});

export const { clearArticlesError } = articlesSlice.actions;
export default articlesSlice.reducer;
